import { render, staticRenderFns } from "./CarrierContract.vue?vue&type=template&id=9f4cf7f8&scoped=true&"
import script from "./CarrierContract.vue?vue&type=script&lang=js&"
export * from "./CarrierContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4cf7f8",
  null
  
)

export default component.exports